module.exports = __webpack_public_path__ + "img/WorldGreyIcon.be384eb1.svg";